import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import Sift from "@/components/sift/Sift";
import AddFile from "@/components/management/file/AddFile";
export default {
  name: "File",
  components: {
    Sift: Sift,
    AddFile: AddFile
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      list: [],
      checkData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      downUrl: this.$http.defaults.baseURL,
      // 下载地址
      url: ""
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {},
  mounted: function mounted() {
    this.fetchSiftData();
  },
  destroyed: function destroyed() {},
  methods: {
    // 搜索框组件数据
    fetchSiftData: function fetchSiftData() {
      var _this = this;

      this.loading = true; // 查询条件 file/getTitleData

      this.$http.get("/file/getTitleData").then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          _this.siftData = data.resData;

          _this.$nextTick(function () {
            _this.initPage();
          });
        } else {
          _this.loading = false;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 获取列表
    getListFn: function getListFn() {
      var _this2 = this;

      var data = this.$refs.needSift.getValue(); // 获取搜索条件的值

      data.pageNum = this.pageNum;
      data.pageSize = this.pageSize;
      data.createUser = "";
      this.$http.post("/file/findPage", data).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode === 0) {
          _this2.list = data.resData.list;
          _this2.total = data.resData.total;
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 下载
    download: function download(row) {
      var _this3 = this;

      this.loading = true;
      this.$http.get("/bigFile/getUrl/" + row.id).then(function (_ref3) {
        var data = _ref3.data;

        if (data.resCode === 0) {
          _this3.url = _this3.downUrl + data.resData + "?token=" + _this3.userToken;

          _this3.$nextTick(function () {
            _this3.$refs.url.click();
          });
        }

        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    // 删除
    deleteFn: function deleteFn(arr) {
      var _this4 = this;

      var ids = [];
      var name = "";

      if (arr) {
        // 单个删除
        ids.push(arr.id);
        name = arr.fileName + " 文件";
      } else {
        // 批量删除
        name = "所选中的文件";
        ids = this.checkData.map(function (val) {
          return val.id;
        });
      }

      this.$confirm("是否确定删除 " + name + " ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this4.loading = true; // 删除接口

        if (arr) {
          // 单个删除
          _this4.deleteOne(ids);
        } else {
          // 批量删除
          _this4.deleteMore(ids);
        }
      }).catch(function () {
        _this4.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.pageNum = 1;
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.getListFn();
    },
    // 上下页
    changePage: function changePage(value) {
      this.pageNum = value;
      this.getListFn();
    },
    // 显示上传弹框
    addFileShow: function addFileShow() {
      var data = {
        limit: 5,
        // 单次上传最大文件数
        title: "请选择上传文件" // 弹框标题

      };
      this.$refs["addFile"].showBox(data);
    },
    // 多选
    checkedFn: function checkedFn(val) {
      this.checkData = val;
    },
    // 单个删除
    deleteOne: function deleteOne(id) {
      var _this5 = this;

      this.$http.delete("/file/removeFile?id=" + id.join(",")).then(function (_ref4) {
        var data = _ref4.data;

        if (data.resCode === 0) {
          _this5.$message.success(data.resMsg);

          _this5.initPage();
        }

        _this5.loading = false;
      }).catch(function () {
        _this5.loading = false;
      });
    },
    // 批量删除
    deleteMore: function deleteMore(ids) {
      var _this6 = this;

      this.$http.delete("/file/deleteFileByButton", {
        data: {
          ids: ids
        }
      }).then(function (_ref5) {
        var data = _ref5.data;

        if (data.resCode === 0) {
          _this6.$message.success(data.resMsg);

          _this6.initPage();
        }

        _this6.loading = false;
      }).catch(function () {
        _this6.loading = false;
      });
    }
  },
  watch: {},
  filters: {}
};